/* NotesViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./NotesViewRenderer");
//const _ = require('lodash');

class NotesViewComponent extends EventEmitter {
    constructor(logger, gameEditor, deviceInstanceId) {
        super();

        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceInstanceId = deviceInstanceId;

        this._note = "When I read the letter you wrote me, it made me mad mad mad. When I read the news that it told me, it made me sad sad sad.";

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        this._deviceInstanceId = undefined;
        this._note = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get logger() {
        return this._logger;
    }
    get deviceInstanceId() {
        return this._deviceInstanceId;
    }

    setNote(newVal) {
        this._note = newVal;
        this.emit("Note", newVal);
        return this;
    }
    getNote() {
        return this._note;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = NotesViewComponent;
NotesViewComponent.$displayDetails = {
    type: "View",
    name: "Notes",
    icon: "common.edit",
    shown: false
};
